<template>
  <div class="runtime-custom-form">
    <div class="dynamic-attr-content" :style="{width: $pScreen.mainW}" ref="dynamicAttrContent">
      <div class="custom-form-title"></div>
      <div class="custom-form-top-img" :style="{height: 374*$pScreen.mainP+'px'}">
        <img
          :style="{width: $pScreen.mainW,height: 374*$pScreen.mainP+'px'}"
          :src="activityPictureUrl"
          alt
        >
      </div>

      <div v-if="invalid">
        <div v-for="(item,index) in questionList" :key="index">
          <div class="dynamic-property-form">
            <component :attrObj="item" :is="item.questionType"></component>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="completedTip">本次问卷活动已结束，感谢您的参与！</div>
        <div class="btn-tool align-center" style="margin-bottom: 48px;">
          <Button
            class="btn-submit"
            :style="{width: $pScreen.textW,height: $pScreen.textH,fontSize:$pScreen.titleS}"
            style="padding-top: 8px; display: none;"
            v-on:click.stop="closePage"
          >关闭</Button>
        </div>
      </div>

    </div>
    <div class="btn-tool align-center" style="margin-bottom: 48px;" v-if="loadedFlag && !submitedFlag && invalid">
      <Button
        class="btn-submit"
        :style="{width: $pScreen.textW,height: $pScreen.textH,fontSize:$pScreen.titleS, background: previewFlag ? '#ccc' : ''}"
        v-on:click.stop="submit"
        style="padding-top: 8px;"
        :disabled="isDisabled || previewFlag"
      >{{submitDocument}}</Button>
    </div>
    <submitedModal :awardObj="awardObj" ref="submitedModal"></submitedModal>
  </div>
</template>

<style>
.is-item-required:before {
  content: "*";
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 16px;
  color: #ed3f14;
  float: left;
  margin-top: -1px;
}
.is-check-error {
  /* border: 1px solid #ed3f14; */
  border: 1px dashed #FF3D17;
  width: 96%;
  /* margin: 0 auto; */
  /* margin-left: calc(2% - 1px); */
  box-sizing: border-box;
}
.radio-content {
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
  margin-bottom: 8px;
}
.radio-title {
  width: calc(100vw - 30px);
  /* font-size: 28px; */
  color: #333;
  padding: 10px 25px 8px 25px;
  font-size: 12px !important;
  font-weight: bold;
}
.runtime-custom-form .dynamic-attr-content {
  font-size: 24px;
  width: 750px;
  background-color: whitesmoke;
  margin: 0 auto;
}
.runtime-custom-form .dynamic-attr-content .radio-options {
  width: calc(100vw - 30px);
  /* border-top: 1px solid #e4e4e4; */
  /* height: 80px; */
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #333333;
  height: 20px !important;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child {
  border-bottom: 0;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child:after {
  height: 0;
}
.radio-options-content {
}
.radio-options-label {
  display: inline-block;
  font-size: 14px;
  color: #333;
}
.radio-options-value {
  float: right;
}
/* .radio-options-value .ivu-icon {
  font-size: 24px;
} */
.radio-options-value .selected .ivu-icon {
  color: #00b1ff;
}
.radio-options-value .selected {
  color: #00b1ff;
  font-size: 16px;
}
.dynamic-attr-text {
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  /* align-items: center; */
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
}
.dynamic-attr-text-title {
  width: 100%;
  /* font-size: 28px; */
  padding: 10px 0 8px 0;
  color: #333;
  font-weight: bold;
  font-size: 12px !important;
  display: block;
  /* align-items: center; */
}
.text-item-value {
  width: 100%;
  margin-bottom: 15px;
}
.text-item-value .ivu-input {
  font-size: 14px;
  /* color: #B2B2B2; */
}
.text-item-input .ivu-input {
  height: 32px;
}
.runtime-custom-form .ihr {
  margin: 0px 0px;
}


.dynamic-attr-file .ivu-upload-select button {
  background: #00b1ff;
  border-radius: 4px;
  color: #ffffff;
  /* width: 187px;
  height: 57px; */
  /* width: 93px; */
  height: 30px;
  font-size: 12px;
  width: 64px;
  padding: 0;
}
.ivu-btn > .ivu-icon {
  font-size: 16px;
}
.radio-options-value .ivu-icon {
  font-size: 16px !important;
}
.ihlp-icon, .ihlp-icon-r {
  color: #B2B2B2;
}
input, textarea{
  -webkit-appearance: none;
}
.dynamic-attr-text{
  margin-bottom: 8px;
}
.ivu-input-wrapper {
  display: block !important;
  line-height: 1 !important;
}
.ivu-btn {
  border: 0 !important;
}
@media (min-width: 750px) {
  .fixedPage {
    left: calc(50% - 375px);
  }
}
 .i-circle, .i-check-circle{
   width: 16px !important;
   height: 16px;
   background: url('../../../../static/runtime/images/magic/radio.png') no-repeat;
   background-size: 100%;
 }
 .i-check-circle {
   background-image: url('../../../../static/runtime/images/magic/radioSelected.png');
 }
 .i-circle:before, .i-check-circle:before, .i-square:before, .i-check-square:before{
   content: " ";
 }
 .i-square, .i-check-square{
   width: 16px !important;
   height: 16px;
   background: url('../../../../static/runtime/images/magic/checkbox.png') no-repeat;
   background-size: 100%;
 }
 .i-check-square {
   background-image: url('../../../../static/runtime/images/magic/checkboxSelected.png');
 }
 .i-circle[disabled], .i-check-circle[disabled], .i-square[disabled], .i-check-square[disabled] {
  opacity: 0.3;
}
.errorTip {
  height: 38px;
  line-height: 40px;
  background: #FFE5E0;
  border-radius: 4px;
  font-size: 12px;
  color: #FF3C16;
  text-indent: 10px;
  margin: 10px 0;
}
.dynamic-property-form {
  background: #fff;
}
.completedTip {
  font-size: 12px;
  text-align: center;
  margin: 30px 0;
}
</style>

<style scoped>
  .runtime-custom-form .btn-submit {
    background-image: linear-gradient(46deg, #1dd3ff 0%, #f22efe 100%);
    border-radius: 87px;
    width: 690px;
    height: 78px;
    font-size: 28px;
    color: #ffffff;
  }
</style>
<script>
import { directive as clickOutside } from "@/utils/component/v-click-outside-x";
import popper from "../../../../static/comjs/popper.min.js";
import single_choice from "./dynamicAttr/radio";
import multiple_choice from "./dynamicAttr/checkbox";
import single_text from "./dynamicAttr/input";
import multiple_text from "./dynamicAttr/textarea";
import attachment from "./dynamicAttr/file";
import attachmented from "./dynamicAttr/selectedFile";
import form_time from "./dynamicAttr/time";
import evaluation from "./dynamicAttr/score";
import submitedModal from './dynamicAttr/modal/NpsModal/submited-modal'
import { Dialog } from 'vant';

export default {
  components: {
    single_choice,
    multiple_choice,
    single_text,
    multiple_text,
    attachment,
    attachmented,
    form_time,
    evaluation,
    submitedModal,
  },
  directives: { clickOutside },
  props: {
    activityObj: {
        type: Object,
        default() {
            return {
                
            }
        }
    }
  },
  data() {
    return {
      dataList: [],
      formCustom: {},
      activityPictureUrl: "",
      questionList: [],
      isDisabled: false,
      submitDocument: "提交",
      awardObj: {},
      showCoupon: false,
      couponList: [],
      pushRecordId: '',
      pushDetailId: '',
      baseConfigId: '',
      memberCode: '',
      activityCode: '',
      loadedFlag: false,
      submitedFlag: false,
      invalid: true,  //问卷是否有效
      previewFlag: false, //预览标识
      sc: '',
      url: '',
    };
  },
  computed: {

  },
  created() {
    console.log(this.$route.query)
    this.id = this.$route.query.id;
    this.code = this.$route.query.activityCode;
    if(this.id){
      this.sc = 'nonauthmkt';
      this.url = "h5/nps/getNPSBaseConfigTemplate/" + this.id
    }else{
      this.sc = 'nonauthmkt';
      this.url = "h5/nps/get2dCodeDataForNpsView/" + this.code
      this.previewFlag = true;
    }
    this.initData();
  },
  //初始化后调用
  mounted: function() {

  },
  methods: {
    //加载表单问题数据
    initData() {
      let self = this;
      self.$api.get({
        sc: this.sc,
        url:  this.url,
        success: r => {
          let result = {};  
          let imageUrl = '';
          if(self.previewFlag){
            result = r.result
          }else{
            result = r.result.result
          }
          let questionList = result.questionList || [];
          let typeArr = ["single_choice", "multiple_choice"];
          if(result.submit){
            self.submitedFlag = result.submit;
            questionList.forEach(item => {
              item.disabled = true;
              if(item.questionType === 'evaluation'){
                item.answerContent = Number(item.answerContent);
              }else if(item.questionType == "attachment"){
                item.questionType = "attachmented"
                if(item.answerContent){
                  item.desc = self.$utils.getImageUrl(item.answerContent);
                }
              }
              let optionList = item.optionList;
              let answerOptionList = item.answerOptionList;
              if(answerOptionList && answerOptionList.length > 0 && typeArr.indexOf(item.questionType) > -1) {
                answerOptionList.forEach(item2 => {
                  optionList.forEach(item3 => {
                    if(item2.optionCode === item3.optionCode){
                      item3._isSelect = true;
                    }
                  })
                })
              }
            })
          }
          if(result.activityMain && result.activityMain.activityPictureUrl){
            imageUrl = JSON.parse(result.activityMain.activityPictureUrl);
            self.activityPictureUrl = self.$utils.getImageUrl(imageUrl.file);
            self.activityCode = result.activityMain.activityCode;
            document.title = result.activityMain.activityName;
          }  
          if(result.npsPushRecord){
            self.pushRecordId = result.npsPushRecord.id;
            self.baseConfigId = result.npsPushRecord.baseConfigId;
            self.memberCode = result.npsPushRecord.npsMemberNo;
          }
          if(result.npsPushDetail){
            self.pushDetailId = result.npsPushDetail.id;
          }
          self.formCustom = result;
          self.questionList = result.questionList;
          self.loadedFlag = true;
          self.invalid = result.invalid;
        }
      })
    },
    submit() {
      let self = this,
        fileQuestion = {},    // 附件
        checkMustFlag = false,
        phoneFlag = false,
        formCustom = self.formCustom,
        questionFalg = false,
        file = []; //questionFalg记录是否需要上传文件
      formCustom.questionList.filter(item => {
        let text = "",
          textArr = [];
        item.answerCodes = [];  
        item.optionList.filter(items => {
          if (
            item.questionType == "multiple_choice" ||
            item.questionType == "single_choice"
          ) {
            if (items._isSelect) {
              text = items.optionCode + ":" + items.optionContent;
              textArr.push(text);
              // if(!item.answerCodes){
              //   item.answerCodes = []
              // }
              item.answerCodes.push(items.optionCode);
            }
            item.answerContent = textArr.join(",");
          }
        });
        //校验必填数据
        if (item.mustFlag == "1") {
          //如果答案没值则校验不通过，如果未上传附件也校验不过
          if (
            (item.answerContent && item.answerContent.toString().trim()) ||
            (item.questionType == "attachment" && item.channelFile) ||
            item.answerContent === 0
          ) {
            self.$set(item, "isCheckError", false);
          } else {
            self.$set(item, "isCheckError", true);
            if(item.phoneNumberVerification && item.phoneNumberVerification != "0"){
              this.$set(item, "errorMsg", '请输入手机号');
            }
            checkMustFlag = true;
          }
        }
        if(item.phoneNumberVerification && item.phoneNumberVerification != "0"){
          if (item.answerContent && item.answerContent.trim()) {
            if(!(/^1[0-9]{10}$/.test(item.answerContent))){
              this.$set(item, "isCheckError", true);
              this.$set(item, "errorMsg", '请输入正确的手机号');
              phoneFlag = true;
            }else{
              this.$set(item, "isCheckError", false);
            }
          }else if(item.mustFlag == '0'){
            this.$set(item, "isCheckError", false);
          }
        }
        if(item.phoneNumberVerification == '2' && item.answerContent && !phoneFlag){
          if (item.verificationCode && item.verificationCode.trim()) {
            this.$set(item, "isCheckError", false);
          } else {
            this.$set(item, "isCheckError", true);
            this.$set(item, "errorMsg", '请输入验证码');
            phoneFlag = true;
          }
        }
        if (item.questionType == "attachment" && item.channelFile) {
          questionFalg = true;
          fileQuestion = item;
        }
      });
      //校验不过，弹出提示
      if (checkMustFlag || phoneFlag) {
        return false;
      }else{
        formCustom.questionList.forEach(item => {
          if(item.phoneNumberVerification == '2'){
            formCustom.verificationCode = item.verificationCode;
            formCustom.redisKey = item.redisKey ;
          }
        })
      }

      if(self.isDisabled){
        return false;
      }
      self.isDisabled = true;
      //如果有文件上传的，先处理文件上传的
      if (questionFalg) {
        for (let i = 0; i < formCustom.questionList.length; i++) {
          const item = formCustom.questionList[i];
          let totalLength=0;
          let uploadIndex=0;
          if (item.questionType == "attachment" && item.channelFile) {
            totalLength++
            setTimeout(function(){
              let params = new FormData();
              let reader = new FileReader();
              //当文件读取成功便可以调取上传的接口，想传哪里传哪里（PS： 你们可以把你们的靓照偷偷发给我！）
              reader.onload = function(e) {
                console.log(i)
                let data = e.target.result;
                //需要上传到服务器的在这里可以进行ajax请求
                self.$api.post({
                  sc: "mobileMarketingH5",
                  params: {file:data,fileName:item.channelFile.name},
                  notFilterNull: true,
                  url: "questionActivity/baseUpload",
                  success: r => {
                    uploadIndex++
                    let result = r.result || "{}";
                    result=JSON.parse(result)
                    item.answerContent = result.file;
                    item.fileName = result.fileName;
                    self.submitSaveoption(totalLength,uploadIndex)
                  },
                  failure:()=>{
                    uploadIndex++
                    self.submitSaveoption(totalLength,uploadIndex)
                    self.isDisabled = false;
                  }
                });
              };
              reader.readAsDataURL(item.channelFile);
            },100)
          }
        }
      } else {
        self.saveoption(formCustom);
      }
    },
    submitSaveoption(totalLength,index){
      if(totalLength===index){
        this.saveoption(this.formCustom)
      }

    },
    saveoption(params) {
      params.activityCode = this.activityCode;
      params.pushRecordId = this.pushRecordId;
      params.pushDetailId = this.pushDetailId;
      params.baseConfigId = this.baseConfigId;
      params.memberCode = this.memberCode;
      let self = this;
      self.$api.post({
        sc: "nonauthmkt",
        params:params,
        url: "h5/nps/commitNpsQuestionNaire",
        success: r => {
          let result = r && r.result;
          // if(result && result.needCoupon === 'Y'){
          //   self.$refs.submitedModal.openModel();
          // }
          // this.awardObj.showModalFlag = result.needCoupon;

          // needCoupon 在OMS ==> 评价系统 ==> NPS配置(奖励设置奖励规则)中配置的有无奖励的字段: 
          // "Y"：表示为 "提交后派券"
          // "N"：表示为 "无奖励"
          if(result){
            self.$refs.submitedModal.openModel();
            this.awardObj.showModalFlag = r.result.needCoupon;
          }
          self.submitedFlag = true;
          self.initData();
        },
        failure:(err) => {
          let content = "活动过于火爆，请稍后再试"
          if(err && err.message){
            content = err.message;
          }
          self.isDisabled = false;
          Dialog.alert({
            title: "提示",
            message: content
          });
        }
      });
    },
    closePage(){
      window.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/nps-form.vue